import type { ReactNode } from 'react';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import { SessionRecordingInlineBlock } from './SessionRecordingInlineBlock';

export const renderSessionRecordingToolUse = (item: ToolUseItem): ReactNode => (
  <SessionRecordingInlineBlock item={item} />
);
